import { type ReactNode } from "react";
import { cn } from "@/lib/utils/common";

interface TableHeaderProps {
  children: ReactNode;
  className?: string;
}

export function TableHeader({ children, className }: TableHeaderProps) {
  return <div className={cn("flex flex-wrap p-2 px-4 gap-2 items-center", className)}>{children}</div>;
}
